import React, { forwardRef } from 'react';

/**
 * Pill / tile chip for tags and similar-works lists.
 *
 * @param {object} props
 * @param {'default'|'indigo'|'muted'} [props.variant='default']
 * @param {boolean} [props.interactive]
 * @param {boolean} [props.locked] — blurred placeholder look
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children
 */
const Chip = forwardRef(function Chip(
  {
    variant = 'default',
    interactive = false,
    locked = false,
    className = '',
    children,
    as: Comp,
    onClick,
    ...rest
  },
  ref
) {
  const Tag = Comp || (interactive || onClick ? 'button' : 'span');
  const variants = {
    default:
      'bg-gradient-to-r from-apple-blue/20 to-apple-purple/20 text-white border border-apple-blue/30',
    indigo:
      'bg-gradient-to-r from-apple-indigo/20 to-apple-purple/20 text-white border border-apple-indigo/30 hover:border-apple-purple/50',
    muted: 'bg-white/[0.06] text-critic-text-muted border border-white/[0.08]',
  };
  const lockedClass = locked ? 'opacity-30 blur-sm text-critic-text-muted pointer-events-none' : '';
  const interactiveClass =
    interactive || onClick
      ? 'cursor-pointer hover:scale-105 transition-all duration-300'
      : '';

  return (
    <Tag
      ref={ref}
      type={Tag === 'button' ? 'button' : undefined}
      onClick={onClick}
      className={`inline-flex items-center justify-center px-4 sm:px-6 py-3 rounded-2xl text-xs sm:text-sm font-semibold backdrop-blur-xl ${
        variants[variant] || variants.default
      } ${lockedClass} ${interactiveClass} ${className}`.trim()}
      {...rest}
    >
      {children}
    </Tag>
  );
});

export default Chip;
